import { useGuestReceiptInformation } from '@/features/update-receipt-information'
import { Dialog } from '@/shared/ui'

import { UpdateReceiptInformationForm } from './form'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  contractId: number
  onSuccess?: () => void
  onClose?: () => void
}

export const UpdateReceiptInformationDialog = ({
  isOpen,
  onOpenChange,
  contractId,
  onSuccess,
  onClose,
}: Props) => {
  const { receiptInformation } = useGuestReceiptInformation({
    contractId,
  })

  const isFormEditable = receiptInformation?.isEditAvailable ?? true

  const handleOpenChange = (open: boolean) => {
    if (isFormEditable && !open) {
      return
    }

    onOpenChange(open)
  }

  const handleClose = () => {
    if (isFormEditable) {
      onClose?.()
    } else {
      onOpenChange(false)
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content className="max-h-[760px] gap-0 p-0" onClose={handleClose}>
        <Dialog.Header className="p-6">
          <Dialog.Title className="text-start">영수증 발급 정보</Dialog.Title>
        </Dialog.Header>
        <UpdateReceiptInformationForm
          contractId={contractId}
          onSuccess={onSuccess}
          onClose={handleClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
